module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./WechatBaseLoginAuthView.js"));
	}, "WechatBaseLoginAuthView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WechatBaseLoginAuthView!./src/pages/Shop/WechatAuth/WechatBaseLoginAuthView.js
// module id = 1384
// module chunks = 418